const getInitials = (name = "") => {
  const trimmedName = name.trim()

  if (trimmedName === "") return null

  const initials = trimmedName.split(" ").length === 1 ? trimmedName.slice(0, 2) : trimmedName.split(" ").map(n => n[0])

  return initials.length === 1 ? initials.toUpperCase() : `${initials[0]}${initials[initials.length - 1]}`.toUpperCase()
}

export default getInitials;
